import React from 'react'
import {
  Location,
  LocationContainer,
  LocationLogo,
  LocationOrderStatus,
} from '../common/Location'
import styled from 'styled-components'
import { themeConWeb } from '@foodsby/nutrient'

const ActiveOrderStatus = ({ order, statusText, loading, locationId }) => {
  return (
    <Component>
      {loading ? null : (
        <Location>
          <LocationContainer
            style={{ display: 'flex', flex: '1 1 auto', alignItems: 'center' }}
          >
            <div className="-logoContainer">
              <LocationLogo
                logoAlt={`${order.storeName} logo`}
                logoLink={order.logoUrl}
              />
            </div>
            <div className="-orderStatusContainer">
              <LocationOrderStatus
                locationId={locationId}
                order={order}
                showManage="true"
                statusText={statusText}
              />
            </div>
          </LocationContainer>
        </Location>
      )}
    </Component>
  )
}

const Component = styled.div`
  padding-right: calc(${themeConWeb.baseUnit} * 8);

  & .location-content {
    flex-wrap: nowrap;
  }

  & .-logoContainer {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    flex-basis: 45%;
  }

  & .-orderStatusContainer {
    padding: 0;
    display: flex;
    flex-direction: column;
    flex-basis: 55%;
  }

  // responsive styles
  @media screen and ${themeConWeb.small} {
    & .location-content {
      flex-wrap: wrap;
    }

    & .-logoContainer {
      flex-basis: 100%;
      justify-content: center;
    }

    & .-orderStatusContainer {
      flex-basis: 100%;
    }
  }
`

export default ActiveOrderStatus
